var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',[_c('Header'),_c('keep-alive',{attrs:{"include":['Article', 'link']}},[_c('router-view',{staticClass:"main"})],1)],1)]),_c('div',{staticClass:"footer"},[_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }